import React from "react";
import { Box } from "@chakra-ui/react";
export function StatsItem(props) {
    return (React.createElement(Box, { flex: "1", minWidth: 0, pb: 1, _notLast: {
            borderRight: "1px solid",
            borderColor: "gray.300",
        }, ...props }));
}
